/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightObservedItinerary } from "./FlightObservedItinerary";
import {
  FlightObservedItineraryFromJSON,
  FlightObservedItineraryFromJSONTyped,
  FlightObservedItineraryToJSON,
  FlightObservedItineraryToJSONTyped,
} from "./FlightObservedItinerary";

/**
 *
 * @export
 * @interface FlightExchangeReplacement
 */
export interface FlightExchangeReplacement {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReplacement
   */
  schemaVersion: FlightExchangeReplacementSchemaVersionEnum;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightExchangeReplacement
   */
  itinerary: FlightObservedItinerary;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReplacement
   */
  cabin: FlightExchangeReplacementCabinEnum;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeReplacement
   */
  pointOfSale: string;
}

/**
 * @export
 */
export const FlightExchangeReplacementSchemaVersionEnum = {
  FlightExchangeReplacementV1: "flight-exchange-replacement-v1",
} as const;
export type FlightExchangeReplacementSchemaVersionEnum =
  (typeof FlightExchangeReplacementSchemaVersionEnum)[keyof typeof FlightExchangeReplacementSchemaVersionEnum];

/**
 * @export
 */
export const FlightExchangeReplacementCabinEnum = {
  Economy: "economy",
  PremiumEconomy: "premium_economy",
  Business: "business",
  First: "first",
} as const;
export type FlightExchangeReplacementCabinEnum =
  (typeof FlightExchangeReplacementCabinEnum)[keyof typeof FlightExchangeReplacementCabinEnum];

/**
 * Check if a given object implements the FlightExchangeReplacement interface.
 */
export function instanceOfFlightExchangeReplacement(
  value: object
): value is FlightExchangeReplacement {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("itinerary" in value) || value["itinerary"] === undefined) return false;
  if (!("cabin" in value) || value["cabin"] === undefined) return false;
  if (!("pointOfSale" in value) || value["pointOfSale"] === undefined)
    return false;
  return true;
}

export function FlightExchangeReplacementFromJSON(
  json: any
): FlightExchangeReplacement {
  return FlightExchangeReplacementFromJSONTyped(json, false);
}

export function FlightExchangeReplacementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeReplacement {
  if (json == null) {
    return json;
  }
  return {
    schemaVersion: json["schema_version"],
    itinerary: FlightObservedItineraryFromJSON(json["itinerary"]),
    cabin: json["cabin"],
    pointOfSale: json["point_of_sale"],
  };
}

export function FlightExchangeReplacementToJSON(
  json: any
): FlightExchangeReplacement {
  return FlightExchangeReplacementToJSONTyped(json, false);
}

export function FlightExchangeReplacementToJSONTyped(
  value?: FlightExchangeReplacement | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    schema_version: value["schemaVersion"],
    itinerary: FlightObservedItineraryToJSON(value["itinerary"]),
    cabin: value["cabin"],
    point_of_sale: value["pointOfSale"],
  };
}
